import React from "react";

import arrowIcon from "../../images/arrow.svg?url";

type ProtectCardProps = {
  title?: string;
  description: React.ReactNode;
  buttonText: string;
  buttonLink?: string;
  onButtonClick?: () => void;
  imageSrc: string;
  overlayText: string;
  disclaimer?: string;
};

export const ProtectCard: React.FC<ProtectCardProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  onButtonClick,
  imageSrc,
  disclaimer,
}) => {
  return (
    <div className="bg-white rounded-[20px] border border-grey-lighter py-7 px-5 flex flex-col items-center h-full">
      {!!title && <h5 className="mb-[30px] text-primary-dark">{title}</h5>}

      <div className="relative w-full h-[300px] mb-8">
        <img
          src={imageSrc}
          alt="Background Image"
          className="w-full h-full object-cover rounded-lg"
        />
      </div>

      <div className="flex flex-col justify-between h-full">
        <div>{description}</div>

        <div className="flex flex-col w-full">
          <a
            href={buttonLink}
            onClick={onButtonClick}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-success text-white font-bold py-3 rounded w-full text-center rounded-[8px] pointer flex items-center justify-center"
          >
            {buttonText}
            <img className="ml-2" src={arrowIcon} alt="arrow" />
          </a>
          <p className="text-xs text-[#A2A2A2] max-w-[300px] mt-2 text-center mx-auto">
            {disclaimer}
          </p>
        </div>
      </div>
    </div>
  );
};
